import React from "react";
import { images } from "../../assets/images";
import { sidebarOptions } from "./sidebarOptions";
import { Link, useLocation, useNavigate } from "react-router-dom";

const DashboardSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const onClickHelp = () => {
    navigate("/helpcenter");
  };

  return (
    <div className="sidebar-container">
      <img
        src={images.mainLogo}
        className="dashboard-logo"
        alt="keventer's logo"
      />
      <div className="sidebar-options">
        {sidebarOptions.map((item, index) => {
          const isActive =
            item.link === "/"
              ? location.pathname === item.link
              : location.pathname.includes(item.link);
          return (
            <Link to={item.link} key={"option-" + index}>
              <div
                className={`sidebar-option ${
                  isActive ? "sidebar-option-active" : ""
                }`}
              >
                <div className="sidebar-option-icon-wrapper">
                  <img src={item.icon} alt="sidebar option icon" />
                </div>
                <div
                  className={`sidebar-option-title font-size-small ${
                    isActive ? "font-family-medium" : ""
                  }`}
                >
                  {item.title}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
      <div className="sidebar-footer">
        <div className="font-size-small text-[var(--ultraLightGray)] mt-6">
          &copy; Powered by CorePeelers
        </div>
      </div>
    </div>
  );
};

export default DashboardSidebar;
